module.exports = __webpack_public_path__ + "static/media/cfBuySell.94bf88ec.png";